import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useDispatch } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import './DoctorNotes.css';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import { LoginService } from '../services/LoginService';
import { getSpecialityData } from '../reduxactions/adminactions/ASpecialityActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Admin_API, DOCTOR_API, SUPRIVISOR_API } from '../ApiNames';
import { StepperPanel } from 'primereact/stepperpanel';
import { Stepper } from 'primereact/stepper';
import { fetchAppointments, fetchCloseCases, fetchOpenCases, fetchUrjentCases } from '../reduxactions/doctoractions/DoctorCasesActions';
import { InputTextarea } from 'primereact/inputtextarea';
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
export const DoctorCases = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('');
    const open = useSelector((state: RootState) => state.doctorcaseslist.open);
    const urjent = useSelector((state: RootState) => state.doctorcaseslist.urjent);
    const close = useSelector((state: RootState) => state.doctorcaseslist.close);
    const appointments = useSelector((state: RootState) => state.doctorcaseslist.appointments);
    const dispatch = useDispatch();
    const stepperRef = useRef(null);
    //To get data
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchOpenCases(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync = async () => {
        try {
            const data = await dispatch(fetchUrjentCases(uid) as any);
            console.log(data);
            setPatientname(data?.patientname);
            console.log(patientName);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync2 = async () => {
        try {
            const payload = { q: 2, userid: uid };
            const apiname = DOCTOR_API.casesdoctor_API;
            const response = await LoginService.getData(apiname, payload);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchDataAsync3 = async () => {
        try {
            await dispatch(fetchCloseCases(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync4 = async () => {
        try {
            await dispatch(fetchAppointments(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffectOnce(() => {
        fetchDataAsync();
        fetchDataAsync1();
        fetchDataAsync2();
        fetchDataAsync3();
        fetchDataAsync4();

    }, [dispatch]);
    const navigate = useNavigate()
    const ViewOpenCase = (rowData: any) => {
        const url = `/casedetails/${rowData.caseid}`;
        console.log('rowdata:', rowData.caseid)
        navigate(url);
    }
    //for assign case
    const [reason, setReason] = useState("");
    const [caseid, setCaseid] = useState('');
    const [acessflag, setAccessflag] = useState('');
    const [sickness, setSickness] = useState('');
    const [sicknessDesc, setSicknessDesc] = useState('');
    const [patientid, setPatientid] = useState('');
    const [trasaction_id, setTreasactionsid] = useState('');
    const [caseAssignEdit, setCaseAssignEdit] = useState(false);
    const [patientName, setPatientname] = useState('');
    const Editdata = (rowData: any) => {
        setCaseid(rowData.caseid || '');
        setAccessflag(rowData.acessflag || '');
        setSickness(rowData.sick || '');
        setSicknessDesc(rowData.sickness_description || '');
        setPatientid(rowData.pid || '');
        setTreasactionsid(rowData.transaction_id || '');

    };

    const toast = useRef<Toast>(null);
    const handleConfirm = async (rowData: any) => {
        try {
            const payload = { ucaseid: rowData.caseid, accessflag: rowData.acessflag, sickness: rowData.sick, description: rowData.sickness_description, patientid: rowData.pid, transactionid: rowData.transaction_id, userid: uid, q: 5 };
            const apiname = DOCTOR_API.casesdoctor_API;
            const data = await LoginService.getData(apiname, payload);
            fetchDataAsync1();
            fetchDataAsync();
            if (toast.current) {
                toast.current.show({ severity: "success", summary: "Confirmed", detail: `Case for ${patientName} has been assigned.`, });
                setReason("");
            }
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };

    const showDialog = (rowData: any) => {
        confirmDialog({
            message: (
                <div>
                    <p> Are you sure?</p>
                    <p>
                        <strong>Patient name:</strong> {rowData.patientname}
                    </p>
                    <p>
                        <strong>Sickness:</strong> {rowData.sick}
                    </p>
                    <p>Once assigned, the case will be shown in Open cases.</p>
                </div>
            ),
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => handleConfirm(rowData),
            reject: () => {
                if (toast.current) {
                    toast.current.show({
                        severity: "info",
                        summary: "Cancelled",
                        detail: "Case assignment was cancelled.",
                    });
                }
            },
        });
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/doctorcases.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="main-content">
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-9">
                                <h2> Cases List</h2>
                            </div>
                            <div className="col-3">
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2"></div>
                            <div className="box box-primary">
                                <div className="card"></div>
                                <div className="card flex flex-wrap justify-content">
                                </div>
                                <div className="card">
                                    <Stepper ref={stepperRef}>
                                        <StepperPanel header="Open Cases">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={open} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="pname" sortable header="Patient Name" />
                                                            <Column field="cdate" sortable header="Date"></Column>
                                                            {/* <Column field="cstatus" sortable header="Status"></Column> */}
                                                            <Column header="Status" sortable body={(rowData) => rowData.cstatus ? rowData.cstatus.charAt(0).toUpperCase() + rowData.cstatus.slice(1).toLowerCase() : ''} />
                                                            <Column field="caseid" sortable header="CaseID"></Column>
                                                            <Column header="Operations" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewOpenCase(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>


                                        <StepperPanel header="Urgent Cases">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={urjent} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="patientname" sortable header="Patient Name" />
                                                            <Column field="sick" sortable header="Sickness" />
                                                            <Column field="cedate" sortable header="Date"></Column>
                                                            <Column field="cstatus" sortable header="Status"></Column>
                                                            <Column header="Status" sortable body={(rowData) => rowData.cstatus ? rowData.cstatus.charAt(0).toUpperCase() + rowData.cstatus.slice(1).toLowerCase() : ''} />
                                                            <Column header="Option" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-briefcase" tooltip="View" className="p-button mr-1 custom-icon-size" style={{ backgroundColor: 'white', color: 'blue', border: 'none', height: '2.8rem' }} onClick={() => showDialog(rowData)} />


                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>
                                        <StepperPanel header="Close Cases">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={close} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="pname" sortable header="Doctor Name" />
                                                            <Column field="cdate" sortable header="Date"></Column>
                                                            {/* <Column field="cstatus" sortable header="Status"></Column> */}
                                                            <Column header="Status" sortable body={(rowData) => rowData.cstatus ? rowData.cstatus.charAt(0).toUpperCase() + rowData.cstatus.slice(1).toLowerCase() : ''} />
                                                            <Column header="Operations" body={(rowData) => (
                                                                <div className="options-buttons">
                                                                    <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => ViewOpenCase(rowData)} />
                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>
                                        <StepperPanel header="Appointments">
                                            <p className="m-0">
                                                <div>
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <div className="card">
                                                        <DataTable value={appointments} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="fname" sortable header="Patient Name" />
                                                            <Column field="sdate" sortable header="Appointment Date" />
                                                            <Column field="duration" sortable header="Duration"></Column>
                                                            {/* <Column field="skype" sortable header="Skype"></Column> */}
                                                            {/* <Column
                                                                field="skype"
                                                                header="Skype"
                                                                sortable
                                                                body={(rowData) => (
                                                                    <a
                                                                        href={`skype:${rowData.skype}?chat`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ textDecoration: 'none', color: 'blue' }}
                                                                    >
                                                                        {rowData.skype}
                                                                    </a>
                                                                )}
                                                            ></Column> */}
                                                            <Column
                                                                field="skype"
                                                                header="Skype"
                                                                sortable
                                                                body={(rowData) => {
                                                                    if (rowData.status === 'active') {
                                                                        return (
                                                                            <a
                                                                                href={`skype:${rowData.fname}?call`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ textDecoration: 'none', color: 'blue' }}
                                                                            >
                                                                                {rowData.fname}
                                                                            </a>
                                                                        );
                                                                    } else {
                                                                        return <span>{rowData.skype}</span>;
                                                                    }
                                                                }}
                                                            ></Column>

                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </p>
                                        </StepperPanel>

                                    </Stepper>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ConfirmDialog />

            </div >
        </div >
    )
}
